import $ from 'jquery'

$(document).ready(dhsv_vc_button())

function dhsv_vc_button() {}
